import actionTypes from './actionTypes'
import makeUniqueId from 'helpers/makeUniqueId'

const interactiveVideoActions = {
	submitSelectForm(videoId, duration, credits) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_SELECT_FORM,
			videoId,
			duration,
			credits,
		}
	},
	updateVideoSuccess() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPDATE_VIDEO_SUCCESS,
		}
	},
	updateVideoFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPDATE_VIDEO_FAILED,
			error,
		}
	},
	saveInteractiveVideo() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SAVE,
		}
	},
	cancelInteractiveVideo() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_CANCEL,
		}
	},
	cancelInteractiveRejected() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_CANCEL_REJECTED,
		}
	},
	cancelInteractiveConfirmed() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_CANCEL_CONFIRMED,
		}
	},
	saveInteractiveVideoSuccess() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SAVE_SUCCESS,
		}
	},
	saveInteractiveVideoFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SAVE_FAILED,
			error,
		}
	},
	publishInteractiveVideoSuccess(redirectUrl) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PUBLISH_SUCCESS,
			redirectUrl,
		}
	},
	publishInteractiveVideoError(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PUBLISH_ERROR,
			error,
		}
	},
	interactiveVideoDataSuccess(data) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SESSION_DATA_SUCCESS,
			data,
		}
	},
	interactiveVideoDataFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SESSION_DATA_FAILED,
			error,
		}
	},
	participantSubmissionsFetched(oeqSubmissions, mcqSubmissions) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PARTICIPANT_SUBMISSIONS_FETCHED,
			oeqSubmissions,
			mcqSubmissions,
		}
	},
	participantSubmissionsFetchedFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PARTICIPANT_SUBMISSIONS_FETCHED_FAILED,
			error,
		}
	},
	interactiveVideoAssetPosterFetched(poster) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ASSET_POSTER_FETCHED,
			poster,
		}
	},
	interactiveVideoAssetPosterFetchedFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ASSET_POSTER_FETCHED_FAILED,
			error,
		}
	},
	interactiveVideoAssetVideoFetched(video) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ASSET_VIDEO_FETCHED,
			video,
		}
	},
	interactiveVideoAssetVideoFetchedFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ASSET_VIDEO_FETCHED_FAILED,
			error,
		}
	},
	sessionInteractiveVideoInitialized() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SESSION_INITIALIZED_CONTAINER,
		}
	},
	interactiveVideoPlayerInitialized() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PLAYER_INITIALIZED,
		}
	},
	breakpointActivitySelected(breakpointActivityUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_SELECTED,
			breakpointActivityUid,
		}
	},
	breakpointActivityReached(breakpointActivityUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_REACHED,
			breakpointActivityUid,
		}
	},
	breakpointActivityConfirmed(breakpointActivityUid, shouldRememberOption) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_CONFIRMED,
			breakpointActivityUid,
			shouldRememberOption,
		}
	},
	breakpointActivityDismissed(shouldRememberOption) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_DISMISSED,
			shouldRememberOption,
		}
	},
	interactiveVideoSessionStatusFetched(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SESSION_STATUS_FETCHED,
			payload,
		}
	},
	interactiveVideoPreviewFetchSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PREVIEW_FETCH_SUCCESS,
			payload,
		}
	},
	interactiveVideoPreviewFetchFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PREVIEW_FETCH_FAILED,
			error,
		}
	},
	playSelected() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PLAY_SELECTED,
		}
	},
	seekSelected() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SEEK_SELECTED,
		}
	},
	pauseSelected() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PAUSE_SELECTED,
		}
	},
	seekEnded() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SEEK_ENDED,
		}
	},
	playCreateSelected() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATE_PLAY_SELECTED,
		}
	},
	mediaDataFetched(data) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MEDIA_DATA_FETCHED,
			data,
		}
	},
	mediaDataFailed() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MEDIA_DATA_FAILED,
		}
	},
	activityPanelCollapseToggle() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ACTIVITY_PANEL_COLLAPSE_TOGGLE,
		}
	},
	interactiveModeToggle() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE,
		}
	},
	interactiveModeToggleConfirmAccepted(doNotShowAgain) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE_CONFIRM_ACCEPTED,
			doNotShowAgain,
		}
	},
	interactiveModeToggleConfirmRejected(doNotShowAgain) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE_CONFIRM_REJECTED,
			doNotShowAgain,
		}
	},
	lessonStreamModeConfirmed(streamMode, applyForAllLessons) {
		return {
			type: actionTypes.SESSION_SETTINGS_STREAM_MODE_UPDATE,
			streamMode,
			applyForAllLessons,
		}
	},
	createInteractiveVideoSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATE_SUCCESS,
			payload,
		}
	},
	createInteractiveVideoFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATE_FAILED,
			error,
		}
	},
	uploadVideoPicked(file) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_PICKED,
			file,
			lessonUID: null,
		}
	},
	uploadVideoCancel() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_CANCEL,
		}
	},
	uploadVideoCancelSuccess() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_CANCEL_SUCCESS,
		}
	},
	uploadVideoError(message) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_ERROR,
			message,
		}
	},
	uploadVideoSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_SUCCESS,
			payload,
		}
	},
	uploadVideoFailed(serverError, upgradeSource) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_FAILED,
			serverError,
			upgradeSource,
		}
	},
	uploadCredits(credits) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_CREDITS,
			credits,
		}
	},
	uploadCreditsFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_CREDITS_FAILED,
			error,
		}
	},
	uploadCreditsSuccess(credits) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_CREDITS_SUCCESS,
			credits,
		}
	},
	openSettings() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_OPEN,
		}
	},
	getVideoSettingsSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_GET_SUCCESS,
			payload,
		}
	},
	getVideoSettingsFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_GET_FAILED,
			error,
		}
	},
	saveVideoSettings(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_SAVE,
			payload,
		}
	},
	closeVideoSettings() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_CLOSE,
		}
	},
	saveVideoSettingsSuccess(payload, videoStatus) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_SAVE_SUCCESS,
			payload,
			videoStatus,
		}
	},
	saveVideoSettingsFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_SETTINGS_SAVE_FAILED,
			error,
		}
	},
	uploadPosterPicked(file) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_POSTER_PICKED,
			file,
		}
	},
	uploadPosterError(message) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_POSTER_ERROR,
			message,
		}
	},
	uploadPosterSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_POSTER_SUCCESS,
			payload,
		}
	},
	uploadPosterFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_POSTER_FAILED,
			error,
		}
	},
	uploadTranscriptPicked(file) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_PICKED,
			file,
		}
	},
	uploadTranscriptError(message) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_ERROR,
			message,
		}
	},
	uploadTranscriptSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_SUCCESS,
			payload,
		}
	},
	uploadTranscriptFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_FAILED,
			error,
		}
	},
	uploadQuestionPicked(file) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_PICKED,
			file,
		}
	},
	uploadQuestionError(message) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_ERROR,
			message,
		}
	},
	uploadQuestionSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_SUCCESS,
			payload,
		}
	},
	uploadQuestionFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_FAILED,
			error,
		}
	},
	saveActivityDraft(activityUid, value) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SAVE_ACTIVITY_DRAFT,
			activityUid,
			value,
		}
	},
	enableCurrentActivityDraft() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ENABLE_CURRENT_ACTIVITY_DRAFT,
		}
	},
	mcqComponentUnmounted(questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MCQ_COMPONENT_UNMOUNTED,
			questionUid,
		}
	},
	submitMcqAnswer(questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER,
			questionUid,
		}
	},
	maxTimeReachedChanged(value) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MAX_TIME_REACHED,
			value,
		}
	},
	endOfVideoReached() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_END_OF_VIDEO_REACHED,
		}
	},
	submitMcqAnswerCancelled() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER_CANCELLED,
		}
	},
	submitMcqAnswerSuccess(questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER_SUCCESS,
			questionUid,
		}
	},
	submitMcqAnswerFailed(error, questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER_FAILED,
			error,
			questionUid,
		}
	},
	oeqComponentUnmounted(questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_OEQ_COMPONENT_UNMOUNTED,
			questionUid,
		}
	},
	submitOeqAnswer(questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER,
			questionUid,
		}
	},
	submitOeqAnswerCancelled() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER_CANCELLED,
		}
	},
	submitOeqAnswerSuccess(questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER_SUCCESS,
			questionUid,
		}
	},
	submitOeqAnswerFailed(error, questionUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER_FAILED,
			error,
			questionUid,
		}
	},
	shareMcqSolution() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MCQ_SHARE_SOLUTION,
		}
	},
	shareMcqSolutionFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MCQ_SHARE_SOLUTION_FAILED,
			error,
		}
	},
	unshareMcqSolution() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MCQ_UNSHARE_SOLUTION,
		}
	},
	unshareMcqSolutionFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_MCQ_UNSHARE_SOLUTION_FAILED,
			error,
		}
	},
	shareParticipantSubmission(participantUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_OEQ_SHARE_PARTICIPANT_SUBMISSION,
			participantUid,
		}
	},
	shareParticipantSubmissionFailed(participantUid, error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_OEQ_SHARE_PARTICIPANT_SUBMISSION_FAILED,
			participantUid,
			error,
		}
	},
	unshareParticipantSubmission(participantUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_OEQ_UNSHARE_PARTICIPANT_SUBMISSION,
			participantUid,
		}
	},
	unshareParticipantSubmissionFailed(participantUid, error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_OEQ_UNSHARE_PARTICIPANT_SUBMISSION_FAILED,
			participantUid,
			error,
		}
	},
	participantJoinedSession(participantUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PARTICIPANT_JOINED_SESSION,
			participantUid,
		}
	},
	uploadVideoStatusFailed(serverError) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_STATUS_FAILED,
			serverError,
		}
	},
	uploadVideoStatusSuccess() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_STATUS_SUCCESS,
		}
	},
	addNewActivity(breakpointTime) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_ADD_NEW_ACTIVITY,
			breakpointTime,
			breakpointClientId: makeUniqueId(),
		}
	},
	editActivity(breakpointActivityUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDIT_ACTIVITY,
			breakpointActivityUid,
		}
	},
	editActivitySuccess(activityType, newActivityUid, breakpointActivityUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDIT_ACTIVITY_SUCCESS,
			activityType,
			newActivityUid,
			breakpointActivityUid,
		}
	},
	editActivityError(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDIT_ACTIVITY_ERROR,
			error,
		}
	},
	cancelNewActivity(breakpointClientId) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CANCEL_NEW_ACTIVITY,
			breakpointClientId,
		}
	},
	createActivity(activityType, breakpointClientId) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ACTIVITY_CREATE,
			activityType,
			breakpointClientId,
		}
	},
	createActivitySuccess(activityType, breakpointClientId, breakpointUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ACTIVITY_CREATE_SUCCESS,
			activityType,
			breakpointClientId,
			breakpointUid,
		}
	},
	createActivityError(breakpointClientId, error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_ACTIVITY_CREATE_ERROR,
			breakpointClientId,
			error,
		}
	},
	exitSelected() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_EXIT_SELECTED,
		}
	},
	exitSelectedConfirmAccepted() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_EXIT_SELECTED_CONFIRM_ACCEPTED,
		}
	},
	exitSelectedConfirmRejected() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_EXIT_SELECTED_CONFIRM_REJECTED,
		}
	},
	interactiveVideoLessonFetched(entity) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_LESSON_FETCHED,
			entity,
		}
	},
	interactiveVideoLessonFetchFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_LESSON_FETCH_FAILED,
			error,
		}
	},
	interactiveVideoNotificationsFetchSuccess(payload) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_NOTIFICATIONS_FETCH_SUCCESS,
			payload,
		}
	},
	interactiveVideoNotificationsFetchFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_NOTIFICATIONS_FETCH_FAILED,
			error,
		}
	},
	interactiveModeToggleConfirmDismissedFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE_CONFIRM_DISMISSED_FAILED,
			error,
		}
	},
	activityDelete() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE,
		}
	},
	activityDeleteConfirmed() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_CONFIRMED,
		}
	},
	activityDeleteSuccess(breakpointUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_SUCCESS,
			breakpointUid,
		}
	},
	activityDeleteFailed(error) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_FAILED,
			error,
		}
	},
	activityDeleteCanceled() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_CANCELED,
		}
	},
	qualitySelected(qualityId) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_QUALITY_SELECTED,
			qualityId,
		}
	},
	userLeftSession(progressCompleted) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SESSION_USER_LEFT,
			progressCompleted,
		}
	},
	playbackSpeedSelected(playbackSpeedId) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PLAYBACK_SPEED_SELECTED,
			playbackSpeedId,
		}
	},
	previewSessionExit() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PREVIEW_SESSION_EXIT,
		}
	},
	welcomeModalLetsDoIt(tooltipName) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_WELCOME_MODAL_LETS_DO_IT,
			tooltipName,
		}
	},
	cancelActivity: isModified => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL,
		isModified,
	}),
	cancelActivityRejected: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL_REJECTED,
	}),
	cancelActivityConfirmed: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL_CONFIRMED,
	}),
	mediaRangeExited: time => ({
		type: actionTypes.INTERACTIVE_VIDEO_MEDIA_RANGE_EXITED,
		time,
	}),
	updateBreakpointPosition: (value, breakpointUid) => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_BREAKPOINT_UPDATE_POSITION,
		value,
		breakpointUid,
	}),
	saveBreakpointPosition: breakpointUid => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_BREAKPOINT_SAVE_POSITION,
		breakpointUid,
	}),
	saveBreakpointPositionSuccess: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_BREAKPOINT_SAVE_POSITION_SUCCESS,
	}),
	saveBreakpointPositionFailed: error => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_BREAKPOINT_SAVE_POSITION_ERROR,
		error,
	}),
	continuePostSessionReport: doNotShowAgain => ({
		type: actionTypes.INTERACTIVE_VIDEO_CONTINUE_POST_SESSION_REPORT,
		doNotShowAgain,
	}),
	handoutsFetched(mediaUid, handouts, assets) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_HANDOUTS_FETCHED,
			mediaUid,
			handouts,
			assets,
		}
	},
	saveStoreParentIdFailed: error => ({
		type: actionTypes.INTERACTIVE_VIDEO_SAVE_STORE_PARENT_ID_ERROR,
		error,
	}),
	goToPicker: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_GOTO_PICKER,
	}),
	assetUnlinkSuccess: data => ({
		type: actionTypes.INTERACTIVE_VIDEO_ASSET_VIDEO_UNLINK_SUCCESS,
		data,
	}),
	assetUnlinkFailed: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_ASSET_VIDEO_UNLINK_FAILED,
	}),
	videoProgressEvent: progress => ({
		type: actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_PROGRESS,
		progress,
	}),
	slideChanged: (canDispatchOnSlideChange, shouldEnforceSubmission) => ({
		type: actionTypes.INTERACTIVE_VIDEO_SLIDE_CHANGED,
		canDispatchOnSlideChange,
		shouldEnforceSubmission,
	}),
	participantLimitReached() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PARTICIPANT_LIMIT_REACHED,
		}
	},
	videoChangeVolume: volume => ({
		type: actionTypes.INTERACTIVE_VIDEO_VOLUME_SELECTED,
		volume,
	}),
	handleMuteSelected: isMuted => ({
		type: actionTypes.INTERACTIVE_VIDEO_TOGGLE_MUTE_SELECTED,
		isMuted,
	}),
	onEmbedInSlide: externalUid => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE,
		externalUid,
	}),
	submitBlankAnswerMCQ: questionUid => ({
		type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_BLANK_ANSWER_MCQ,
		questionUid,
	}),
	closeInteractiveVideoBlankResponsePromptMCQ: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CLOSE_BLANK_RESPONSE_PROMPT_MCQ,
	}),
	submitBlankAnswerOEQ: questionUid => ({
		type: actionTypes.INTERACTIVE_VIDEO_SUBMIT_BLANK_ANSWER_OEQ,
		questionUid,
	}),
	closeInteractiveVideoBlankResponsePromptOEQ: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CLOSE_BLANK_RESPONSE_PROMPT_OEQ,
	}),
	closeInteractiveVideoPreventSkippingPrompt: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CLOSE_PREVENT_SKIPPING_PROMPT,
	}),
	closeInteractiveVideoSubmissionsRequired: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CLOSE_SUBMISSIONS_REQUIRED,
	}),
	videoEditorWelcomeTourLetsDoIt: tooltipName => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_LETS_DO_IT,
		tooltipName,
	}),
	videoEditorWelcomeTourSkipTour: tooltipNames => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_SKIP_TOUR,
		tooltipNames,
	}),
	videoEditorWelcomeTourStep1GotIt: tooltipName => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_1_GOT_IT,
		tooltipName,
	}),
	videoEditorWelcomeTourStep2GotIt: tooltipName => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_2_GOT_IT,
		tooltipName,
	}),
	videoEditorWelcomeTourStep3GotIt: tooltipName => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_3_GOT_IT,
		tooltipName,
	}),
	saveInteractiveVideoEmbedSuccess: externalUid => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE_SAVE_SUCCESS,
		externalUid,
	}),
	saveInteractiveVideoEmbedFailed: error => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE_SAVE_FAILED,
		error,
	}),
	videoCaptionsFetchSuccess: captions => ({
		type: actionTypes.INTERACTIVE_VIDEO_CAPTIONS_FETCH_SUCCESS,
		captions,
	}),
	videoCaptionsFetchFailed: error => ({
		type: actionTypes.INTERACTIVE_VIDEO_CAPTIONS_FETCH_FAILED,
		error,
	}),
	languageSelected: language => ({
		type: actionTypes.INTERACTIVE_VIDEO_CAPTIONS_LANGUAGE_SELECTED,
		language,
	}),
	trimToolUnsavedBack: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_UNSAVED_BACK,
	}),
	trimToolUnsavedTrimAndSave: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_UNSAVED_TRIM_AND_SAVE,
	}),
	trimToolOnDragTrimStart: time => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_ON_DRAG_TRIM_START,
		time,
	}),
	trimToolOnDragTrimEnd: time => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_ON_DRAG_TRIM_END,
		time,
	}),
	trimToolOpen: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_OPEN,
	}),
	trimToolCancel: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_CANCEL,
	}),
	trimToolSaveTrim: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_SAVE_TRIM,
	}),
	trimToolSaveTrimSuccess: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_SAVE_TRIM_SUCCESS,
	}),
	trimToolSaveTrimFailed: error => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_SAVE_TRIM_FAILED,
		error,
	}),
	trimToolTrimTooltipGotIt: tooltipName => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_TRIM_TOOLTIP_GOT_IT,
		tooltipName,
	}),
	participantStateFetched: participantState => ({
		type: actionTypes.INTERACTIVE_VIDEO_PARTICIPANT_STATE_FETCHED,
		participantState,
	}),
	tooltipCheckProgressDismissed: tooltipName => ({
		type: actionTypes.INTERACTIVE_VIDEO_TOOLTIP_CHECK_PROGRESS_DISMISSED,
		tooltipName,
	}),
}

export default interactiveVideoActions
